import $ from 'jquery';
import 'jquery-mousewheel';
import fitty from 'fitty';

export default {
  init() {

    const fitties = fitty('.fitty-span', {
      maxSize: 150,
    });

    window.setTimeout(() => {
      fitties.forEach((fitty) => {
        fitty.fit();
      });
    }, 100);

    $('#application-category__list').mousewheel(function(e) {

      if($(window).width() < 768 || $(window).height() < 870) return;
      
      e.preventDefault();

      if(e.deltaY) {
        this.scrollLeft -= (e.deltaY * e.deltaFactor);
      } else {
        this.scrollLeft += (e.deltaX * e.deltaFactor);
      }
  

      $('#application-category__fade-out').css({
        'opacity' : 1 - ( this.scrollLeft / 400 ),
      });

   });
    
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/tax-application_category.js